// extracted by mini-css-extract-plugin
export default {"wrapper":"l1W7ALbJ","dense":"RLR7ZN5T","label":"j_DhhP6o","notInline":"yqg1bMUX","optional":"Ab8fKomk"};